import React from "react";
import StatusIcon from "../../components/QueueAttendance/subcomponents/StatusIcons";

const ChatIcon = (type, { color } = {}) => {
  switch (type) {
    case "overdue":
      return {
        color: "#f46a6a",
        icon: (
          <StatusIcon
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fillcolor="#f46a6a"
            fillRule="evenodd"
            stroke="#f46a6a"
            strokeWidth=".5"
            d="M10.664 1.112C10.32.517 9.687.15 9 .15c-.687 0-1.32.366-1.664.96L.26 13.368c-.343.595-.343 1.327 0 1.921.344.595.978.961 1.664.961h14.152c.686 0 1.32-.366 1.664-.96.343-.595.343-1.327 0-1.922L10.664 1.112zm6.037 13.576c-.128.225-.367.364-.625.361H1.924c-.258 0-.496-.137-.625-.36-.128-.223-.128-.498 0-.722L8.375 1.712c.129-.224.367-.361.625-.361s.496.137.625.36l7.076 12.256c.131.223.131.499 0 .721z"
            transform="translate(1.736 1)"
            done="M9 10.977c.331 0 .6-.268.6-.6V5.086c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6v5.29c0 .333.269.6.6.6zM9 12.184c-.257 0-.488.154-.587.391-.098.238-.043.51.138.692.182.182.454.236.692.138.237-.098.392-.33.392-.587 0-.168-.067-.33-.186-.448-.12-.12-.28-.186-.449-.186h0z"
            transformone="translate(1.736 1)"
            customStyle={{
              width: "16px",
              height: "15px",
              objectFit: "contain",
            }}
          />
        ),
      };
    case "burstingTime":
      return {
        color: "#f1b44d",
        icon: (
          <StatusIcon
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fillcolor="#f1b44d"
            fillRule="evenodd"
            stroke="#f1b44d"
            d="M15.671 17h-.158c-.812-.06-4.554-.573-5.683-4.208H4.484c-1.841 0-3.327-1.481-3.327-3.318V4.338C1.138 2.48 2.623 1 4.465 1h9.366c1.841 0 3.326 1.481 3.326 3.319v5.136c0 1.56-1.069 2.884-2.574 3.239.139 2.43.614 3.358 1.03 3.397h.04c.257 0 .455.218.435.454.04.257-.159.455-.417.455h0zM4.465 1.909c-1.347 0-2.416 1.086-2.416 2.41v5.136c0 1.343 1.09 2.41 2.416 2.41h5.702c.219 0 .396.137.436.335.574 2.31 2.376 3.239 3.663 3.634-.336-.79-.534-1.955-.594-3.516 0-.237.178-.435.416-.474 1.248-.119 2.178-1.165 2.178-2.41V4.3c0-1.344-1.089-2.41-2.415-2.41H4.465v.02z"
            customStyle={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
            }}
          />
        ),
      };
    case "progress":
      return {
        color: "#34c38f",
        icon: (
          <StatusIcon
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fillcolor="#34c38f"
            fillRule="evenodd"
            stroke="#34c38f"
            d="M15.671 17h-.158c-.812-.06-4.554-.573-5.683-4.208H4.484c-1.841 0-3.327-1.481-3.327-3.318V4.338C1.138 2.48 2.623 1 4.465 1h9.366c1.841 0 3.326 1.481 3.326 3.319v5.136c0 1.56-1.069 2.884-2.574 3.239.139 2.43.614 3.358 1.03 3.397h.04c.257 0 .455.218.435.454.04.257-.159.455-.417.455h0zM4.465 1.909c-1.347 0-2.416 1.086-2.416 2.41v5.136c0 1.343 1.09 2.41 2.416 2.41h5.702c.219 0 .396.137.436.335.574 2.31 2.376 3.239 3.663 3.634-.336-.79-.534-1.955-.594-3.516 0-.237.178-.435.416-.474 1.248-.119 2.178-1.165 2.178-2.41V4.3c0-1.344-1.089-2.41-2.415-2.41H4.465v.02z"
            customStyle={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
            }}
          />
        ),
      };
    case "inactive":
      return {
        color: "#51a6f1",
        icon: (
          <StatusIcon
            width="19"
            height="20"
            viewBox="0 0 19 20"
            fillcolor="#51a6f1"
            fillRule="evenodd"
            stroke="#51a6f1"
            strokeWidth=".56"
            d="M9.539 1C4.598 1 .579 5.019.579 9.96c0 4.941 4.019 8.96 8.96 8.96 4.94 0 8.96-4.019 8.96-8.96 0-4.941-4.02-8.96-8.96-8.96zm0 1.195c4.295 0 7.765 3.47 7.765 7.765 0 4.296-3.47 7.765-7.765 7.765-4.296 0-7.766-3.47-7.766-7.765 0-4.296 3.47-7.765 7.766-7.765zm-.405 2.178c-.16.001-.312.066-.423.18-.11.116-.171.27-.168.43v5.375c0 .33.268.598.597.598h5.376c.16.002.315-.06.428-.172.115-.112.178-.265.178-.426 0-.16-.063-.313-.178-.425-.113-.112-.267-.174-.428-.172H9.738V4.982c.003-.161-.06-.318-.173-.432-.113-.115-.269-.179-.43-.177h0z"
            customStyle={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
            }}
          />
        ),
      };
    case "exception":
      return {
        icon: (
          <StatusIcon
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fillcolor={color ?? "#f46a6a"}
            fillRule="evenodd"
            strokeWidth=".56"
            d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m0 16H5V10h14v10M5 8V6h14v2H5m3.23 9.41l1.06 1.06l2.44-2.44l2.44 2.44l1.06-1.06l-2.44-2.44l2.44-2.44l-1.06-1.06l-2.44 2.44l-2.44-2.44l-1.06 1.06l2.44 2.44l-2.44 2.44Z"
            customStyle={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
              opacity: "0.3"
            }}
          />
        ),
      };
    default:
      return {
        color: "#74788D",
        icon: (
          <StatusIcon
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fillcolor="#74788D"
            fillRule="evenodd"
            stroke="#74788D"
            strokeWidth=".25"
            d="M9.02.088c-2.37 0-4.64.94-6.316 2.617C1.03 4.379.088 6.65.088 9.02c0 2.37.94 4.64 2.616 6.316 1.675 1.675 3.947 2.617 6.316 2.617 2.37 0 4.64-.941 6.316-2.617 1.675-1.675 2.616-3.947 2.616-6.316 0-2.37-.94-4.64-2.616-6.315C13.66 1.029 11.389.088 9.02.088zm0 16.543v.001c-2.019 0-3.955-.802-5.382-2.23-1.428-1.427-2.23-3.363-2.23-5.382 0-2.019.802-3.955 2.23-5.382C5.065 2.21 7 1.408 9.02 1.408c2.019 0 3.955.802 5.382 2.23C15.83 5.065 16.632 7 16.632 9.02c0 2.019-.802 3.955-2.23 5.382-1.427 1.428-3.363 2.23-5.382 2.23h0z"
            transform="translate(1 1)"
            done="M12.1 6.314L7.964 10.23 6.07 8.294h.001c-.255-.261-.673-.267-.935-.011-.261.255-.266.673-.01.935l2.353 2.398c.117.13.286.204.462.198.17-.005.332-.066.462-.176l4.598-4.356c.264-.245.284-.655.044-.924-.253-.267-.67-.287-.946-.044h0z"
            transformone="translate(1 1)"
            customStyle={{
              width: "16px",
              height: "16px",
              objectFit: "contain",
            }}
          />
        ),
      };
  }
};

export default ChatIcon;
